// Per-environment, non-secret build constants for the frontend.
// The environment is selected by the Vite mode: `npm run build:dev` (vite build --mode dev) or
// `npm run build:prod` (--mode prod), per the deploy procedure. Never put a secret here: everything
// in this file ships in the public bundle. See docs/gen2-migration/decisions/ADR-004.
const ENVIRONMENTS = {
  dev: {
    // Allowed student email domain for login, registration and password reset. Empty = any domain.
    studentEmailDomain: '',
    // Google Tag Manager container id. Empty = GTM is not loaded.
    gtmContainerId: '',
  },
  prod: {
    studentEmailDomain: 'st.swu.ac.jp',
    gtmContainerId: '',
  },
};

// The `vite` dev server reports mode 'development' and a plain `vite build` reports 'production'.
// Both fall back to the dev values, so production values can only come from `--mode prod`.
export const appEnv = ENVIRONMENTS[import.meta.env.MODE] ?? ENVIRONMENTS.dev;

export const gtmConfig = {
  containerId: appEnv.gtmContainerId,
};
